<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onCancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Create a Category
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list class="ion-padding">
    <form [formGroup]="serviceCategoryForm">
      <ion-item lines="none">
        <ion-label position="stacked" class="ion-padding-bottom"
          >Category Name</ion-label
        >
        <ion-input
          type="text"
          name="serviceCategory"
          formControlName="serviceCategory"
          class="smr-input-border"
          clearInput
        ></ion-input>
      </ion-item>
    </form>
  </ion-list>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col class="hidden-md-down" size="7"></ion-col>
        <ion-col>
          <ion-button
            fill="outline"
            expand="block"
            (click)="onCancel()"
          >
            Cancel
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" (click)="onSaveCategory()">
            Save
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
